var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.778,
    height: 18.318,
    viewBox: "0 0 18.778 18.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Print_icon",
    d: "M108.4,82.709l-3.354-3.354a2.562,2.562,0,0,0-1.823-.755H99.307a2.577,2.577,0,0,0-2.577,2.577v9.039H97.76V81.177a1.546,1.546,0,0,1,1.546-1.546h3.918a1.465,1.465,0,0,1,.335.04v1.944a2.577,2.577,0,0,0,2.577,2.577h1.948a1.5,1.5,0,0,1,.041.339v5.685h1.031V84.532A2.559,2.559,0,0,0,108.4,82.709Zm-2.264.453a1.563,1.563,0,0,1-1.094-.453,1.541,1.541,0,0,1-.453-1.094V80.36l2.8,2.8Zm4.135,6.134H95.5a2.005,2.005,0,0,0-2,2v3.616a2.005,2.005,0,0,0,2,2h14.772a2.005,2.005,0,0,0,2-2V91.3A2.005,2.005,0,0,0,110.275,89.3Zm1.083,5.619A1.084,1.084,0,0,1,110.275,96H95.5a1.084,1.084,0,0,1-1.083-1.083V91.3A1.084,1.084,0,0,1,95.5,90.217h14.772a1.084,1.084,0,0,1,1.083,1.083Z",
    transform: "translate(-93.5 -78.6)",
    fill: "#1d1f24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/Print_icon.7ab821a0057d9420b9636163efbeb706.svg";
export { ForwardRef as ReactComponent };